import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import analyticsService from '../../services/analytics';
import { normalizeRouteTemplate } from '../../services/analyticsContract';

const AnalyticsRouteObserver = () => {
  const { pathname } = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const hasOpenedRef = useRef(false);
  const previousRouteRef = useRef(null);

  useEffect(() => {
    if (loading || !isAuthenticated) return;

    const routeTemplate = normalizeRouteTemplate(pathname);
    if (!hasOpenedRef.current) {
      analyticsService.trackEvent('app_opened', {
        category: 'core_funnel',
        route_template: routeTemplate
      });
      hasOpenedRef.current = true;
    }

    analyticsService.trackPageView(routeTemplate, {
      previous_route_template: previousRouteRef.current || routeTemplate
    });
    previousRouteRef.current = routeTemplate;
  }, [isAuthenticated, loading, pathname]);

  return null;
};

export default AnalyticsRouteObserver;
